import {Link} from "react-router";

export function DiscoverBreadcrumbs({
	items
}: {
	items: {
		label: string,
		route?: string,
		note?: string | number,
	}[]
}) {

    return (
		<div className="discover-breadcrumbs">
			<span className="discover-breadcrumbs__item">Scout &amp; Discover</span>
			{items.map((item, index) => (
				<span key={`bread-${index}`}>
					<span className="discover-breadcrumbs__pipe"></span>
					<span className={`discover-breadcrumbs__item ${index === items.length - 1 && 'is-last'}`}>
						{(item.route || false) ? <Link to={item.route}>
							{item.label} {item.note && <span className="discover-breadcrumbs__note">{item.note}</span>}
						</Link> : <>
							{item.label} {item.note && <span className="discover-breadcrumbs__note">{item.note}</span>}
						</>}
					</span>
				</span>
			))}
		</div>
)
}
